'use strict' 

export default class Talent
{
  constructor()
  {
    this.$elem = $('.Talent')

    if( this.$elem.length > 0 ){
      this.$form = this.$elem.find('.Talent__form')
      this.$gallery = this.$elem.find('.Talent__gallery')

      let self = this

      $(document).ready(function(){
        self._gallery()
        self._form()
      })
    }
  }

  _gallery(){
    let self = this
    let $itemsLightbox = self.$gallery.find('.gallery_item .venobox')
    
    let generateGrid = ( callback ) => {
      let $gallery = self.$elem.find('.Talent__gallery')
      let $items = $gallery.find('.gallery_item')
      let items_big = []
      let items_small = []
      let gridCreated = false

      $.each($items, function( i,val ){
        if( $(this).children().attr('data-type') == 'image_big' ){
          $(this).addClass('--big')
          items_big.push( $(this) )
        }
        else{
          $(this).addClass('--small')
          items_small.push( $(this) )
        }

        if( i + 1 == $items.length ){
          $items.remove()
          let itemSmallAdded = 0

          for( let i = 0; i <= items_big.length; i++ ){
            if( items_small.length - itemSmallAdded >= 2 ){
              $gallery.append('<div class="gallery_row grid-noGutter-top-center"></div>')

              let $row = $gallery.find('.gallery_row').last()

              if( i % 2 == 0 ) {
                  $row.append( items_big[i] )
              }

              $row.append('<div class="gallery_container_small"></div>')

              $row.children('.gallery_container_small').append( items_small[itemSmallAdded] )
              $row.children('.gallery_container_small').append( items_small[itemSmallAdded + 1] )
              itemSmallAdded += 2

              if( i % 2 != 0 ) {
                $row.append( items_big[i] )
              }
            } else{
              gridCreated = true
            }
          }

          let controller = setInterval(function () {
            if( gridCreated ){
              clearInterval(controller)
              //callback()
            }
          }, 200)
        }
      })
    }
    generateGrid()

    let crossbrowsing = () => {
      let $bigItems = $('.Talent').find('.Talent__gallery .gallery_item.--big')
      let $smallItems = $('.Talent').find('.Talent__gallery .gallery_item.--small')

      if( window.innerWidth >= 1025 ){
        $smallItems.find('.main_image').css({
          'width' : 290,
          'height' : 190
        })
        $bigItems.find('.main_image').css({
          'width' : 700,
          'height' : 383
        })

        if( window.innerWidth >= 1230 ){
          $smallItems.find('.main_image').css({
            'width' : 320,
            'height' : 250
          })
          $bigItems.find('.main_image').css({
            'width' : 877,
            'height' : 503
          })
        }
      } else{
        if( $bigItems.find('.main_image').attr('style') != undefined ){
          $bigItems.find('.main_image').removeAttr('style')
        }
        if( $smallItems.find('.main_image').attr('style') != undefined ){
          $smallItems.find('.main_image').removeAttr('style')
        }
      }
    }
    crossbrowsing()

    $(window).resize( () => {
      crossbrowsing()
    })

    $(window).on("orientationchange", ()=> {
      crossbrowsing()
    })
  }

  _form(){
    let self = this
    
    let animating = false
    let opened = false
    let animTime = 500

    let accordionAction = ( $elem ) => {
      if(!animating){
        animating = true
        $elem.toggleClass('active')

        let $content = $elem.siblings()
        let targetHeight = $content.find('.inner_container').outerHeight()

        if( !opened ){
          opened = true
          $content.stop().animate({
            height: targetHeight
          }, animTime, 'swing', function(){
            setTimeout(function(){
              $content.css({
                'height' : 'auto'
              })
            }, 200)
          })
        } else{
          opened = false
          $content.stop().animate({ height: 0 }, animTime, 'swing')
        }

        setTimeout(function(){ animating = false }, animTime)
        setTimeout(function(){ 
          $('.Page__container').animate({
            'padding-bottom': self.$form.outerHeight()
          }, 600, 'swing', function(){ } )
        }, animTime + 500)

        // Fix, for dispatch scroll event and resize natural height of sidebar
        let counter = 0
        let controller = setInterval(function(){
          if( !animating ){ clearInterval(controller) }
          
          if( counter % 2 == 0 ){
            window.scrollTo(window.scrollX, window.scrollY + 1);
          } else{
            window.scrollTo(window.scrollX, window.scrollY - 1);
          }
          
          counter++;
        }, 10)
      }
    }

    let initialPosTop = self.$form.offset().top
    let initialHeight = self.$form.height()

    self.$form.find('.header_form').on('click', function( event ){ accordionAction( $(this) ) })

    let totalScroll = $(window).scrollTop() + window.innerHeight
    
    if( totalScroll >= self.$gallery.offset().top ){
      self.$form.addClass('-sticky', 300, 'swing')
    }

    // Fix for sticky form
    $('.Page__container').animate({
      'padding-bottom': self.$form.outerHeight()
    }, 600, 'swing', function(){ } )
    $(window).resize( ()=> {
      $('.Page__container').animate({
        'padding-bottom': self.$form.outerHeight()
      }, 600, 'swing', function(){ } )
    })

    $( window ).scroll( ()=> {
      let totalScroll = $(window).scrollTop() + window.innerHeight

      if( totalScroll >= self.$gallery.offset().top ){
        if( !self.$form.hasClass('-sticky') ){
          self.$form.addClass('-sticky', 300, 'swing')
        }

        // Add bottom position
        if( totalScroll >= initialPosTop + self.$form.outerHeight() ){
          if( !self.$form.hasClass('-bottom') ){
            self.$form.addClass('-bottom')
          }
        } else{
          if( self.$form.hasClass('-bottom') ){
            self.$form.removeClass('-bottom')
          }
        }
      } else{
        if( self.$form.hasClass('-sticky') ){
          self.$form.removeClass('-sticky', 300, 'swing')
        }
      }
    })
  }
}




